import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServizioMenuService } from 'src/app/shared/services/servizio-menu.service';
import { Articolo, ArticoloFull } from 'src/app/shared/interfaces/custom/articolo';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-search-list-container',
  templateUrl: './search-list-container.component.html',
  styleUrls: ['./search-list-container.component.scss']
})
export class SearchListContainerComponent implements OnInit {
  items: Articolo[] = [];

  constructor(
    private route: ActivatedRoute,
    private menuService: ServizioMenuService
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.route.paramMap,
      this.route.queryParamMap
    ]).subscribe(([params, queryParams]) => {
      const search = queryParams.get('search');
      if (search) {
        console.log('Sono nella ricerca', search);
        this.items = [];
        // logica di ricerca
        this.menuService.searchProduct(search).subscribe(response => {
          console.log('Risultati ricerca:', response);
          this.items = response;
        });
      } 
    });

    };
  }

